<template>
  <select-input :name="name"
                :required="required"
                :label="label"
                :value="value"
                :options="options"
                :optionsLabel="optionsLabel"
                @input="onInput"
  />
</template>

<script>
import customInputMixin from '@/components/frontoffice/form/customInput/mixin'
import selectInput from '@/components/frontoffice/form/baseInput/select'

export default {
  components: {
    selectInput
  },
  mixins: [customInputMixin],
  props: {
    value: {
      type: [String, Object]
    },
    options: {
      type: Array,
      required: true
    },
    optionsLabel: {
      type: String,
      default: 'text'
    }
  },
  created: function() {
    // update enabled option of options array
    for(var i=0; i<this.options.length; i++) {
      if (this.options[i].enabled === false) this.options[i].isDisabled = true;
    }
  },
  methods: {
    onInput (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
